module.exports = __webpack_public_path__ + "static/media/img_give_back@2x.1fb60619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_give_back@2x.jpg
// module id = 811
// module chunks = 0